export enum ProductTax {
  TaxRate = 8.25,
}

export enum StatusEnum {
  Pending = 0,
  Active = 10,
  Inactive = 20,
}
export enum DeliveryType {
  Recurring = 10,
  CallIn = 20,
}

export enum ButtonType {
  Info = 'info',
  Primary = 'primary',
  Warning = 'warning',
  Success = 'success',
  Danger = 'danger',
  Default = 'default',
  DarkScreen = 'dark-screen',
  Yellow = 'yellow-warning',
  LightBrown = 'light-brown',
  Black = 'black',

  PrimaryOutline = 'primary-outline',
  SuccessOutline = 'success-outline',
  DangerOutline = 'danger-outline',
  DarkScreenOutline = 'dark-screen-outline',

}
// export enum EmployeeTypeEnum {
//   FullTime = 10,
//   PartTime = 20,
//   Contractor = 30,
//   Causal = 40
// }
// export enum EmployeeTypeMap {
//   FullTime = 'Full Time',
//   PartTime = 'Part Time',
//   Contractor = 'Contractor',
//   Causal = 'Casual'
// }
export enum MyDayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

export enum DeliveryStatusTypeEnum {
  Scheduled = 0,
  NotStart = 10,
  Started = 20,
  Cancelled = 30,
  UnableToCompleted = 40,
  PartiallyCompleted = 50,
  Completed = 60
}

export enum DriverConfirmEnum {
  Unknow = 0,
  Watting = 10,
  Reject = 20,
  Accept = 30
}


export enum ContactType {
  DeliveryContact = 10,
  AccountsDepartment = 20,
  BusinessOwner = 30
}

export enum WeekOfMonth {
  First = 10,
  Second = 20,
  Third = 30,
  Fourth = 40,
  Fifth = 50,
}

export enum Region {
  North = 10,
  South = 20,
}

export enum RecurringType {
  Weekly = 10,
  BiWeekly = 20,
  Monthly = 30,
}
export enum BiWeeklyType {
  Even = 10,
  Odd = 20,
}

export enum Ownership {
  PreOwned = 10,
  Purchased = 20,
  Rent = 30,
  SuppliedNoCharge = 40,
}

export enum EquipmentStyle {
  Style1 = 10,
  Style2 = 20,
  Style3 = 30,
}

export enum RoleType {
  Admin = 'Admin',
  Basic = 'Basic',
  SuperAdmin = 'SuperAdmin',
  SystemOwner = 'SystemOwner',
}

export enum OptimizeRoute {
  TimeEfficient = 10,
  Distance = 20,
}
export enum TimeUnit {
  Hour = 10,
  Minute = 20,
  Second = 30,
}
export enum DistanceUnit {
  Mile = 10,
  Km = 20,
}
export enum ClaimType {
  Role = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role',
  Email = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress',
  NameIdentifier = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier',
}
export enum OptimizeType {
  RoundTrip = 10,
  OneWay = 20,
}

export enum PricingPlan {
  Basic = 10,
  Premium = 20
}

export enum MessageStatus {
  Unpublished = 10,
  Published = 20
}

export enum MessageType {
  All = 10,
  Person = 20
}

export enum QuickBookStatus {
  NotIntegrate = 0,
  NotStarted = 10,
  Syncing = 20,
  Success = 30,
  Failed = 40
}

export enum DeliveryContactType {
  Primary = 10,
  Secondary = 20
}

export enum SendInvoiceStatus {
  Procesing = 10,
  Sent = 20,
  Failed = 30,
  //Received = 40
}

export enum InvoiceType {
  Unknown = 0,
  Delivery = 10,
  WalkIn = 20,
  Manual = 30
}

export enum PaymentType {
  Account = 10,
  Cash = 40,
  Check = 30,
  CreditCard = 20,
}